
  <template>
    <nav class="navbar d-print-none" v-if="!skipCalculations">
      <div class="nav-actions">
        <a href="javascript:;" class="restart" @click="startOver()" tabindex="0" role="button" aria-label="Start over">
          <span class="topNav">Start&nbsp;Over</span>
        </a>
      </div>
      <ul class="navbar-nav nav-pills calc-nav">          
        <li class="nav-item" >
          <a class="nav-link about" :class="[this.routeName == 'About' ? 'active' : '',this.prevTab > 0 ? 'completed' : '']" href="#/about"><span class="nav-link-text">About you</span></a>
        </li>
        <li class="nav-item">
          <a class="nav-link debt" :class="[this.routeName == 'Debt' ? 'active' : '', this.prevTab > 1 ? 'completed' : '']" href="#/debt"><span class="nav-link-text">Commitments & debt</span></a>
        </li>
        <li class="nav-item">
          <a class="nav-link income"  :class="[this.routeName == 'Income' ? 'active' : '', this.prevTab > 2 ? 'completed' : '']" href="#/income"><span class="nav-link-text">Income & savings</span></a>
        </li>
        <li class="nav-item">
          <a class="nav-link expenditure" :class="[this.routeName == 'Expenses' ? 'active' : '', this.prevTab > 3 ? 'completed' : '']" href="#/expenses"><span class="nav-link-text">Future expenditure</span></a>
        </li>
        <li class="nav-item">
          <a class="nav-link cover-estimate" :class="[this.routeName == 'Results' ? 'active' : '', this.prevTab > 4 ? 'completed' : '']" href="#/results"><span class="nav-link-text">Cover estimate</span></a>
        </li>
        <li class="nav-item">
          <a class="nav-link occupation" :class="[this.routeName == 'NextOptions' ? 'active' : '', this.prevTab > 5 ? 'completed' : '']" href="#/next-options"><span class="nav-link-text">Member type</span></a>
        </li>
        <li class="nav-item">
          <a class="nav-link costs" :class="[this.routeName == 'CoverCost' ? 'active' : '', this.prevTab > 6 ? 'completed' : '']" href="#/cover-cost"><span class="nav-link-text">Cover costs</span></a>
        </li>
      </ul>
    </nav>

</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  computed: {
    routeName () {
      return this.$route.name
    },
    ...mapFields(["prevTab", "data", "Enum", "skipCalculations", "acceptedDisclaimer"]),
  },
  methods: {
    startOver() {
      // Reset values
      this.$store.commit("setDefaultData");
      this.acceptedDisclaimer = false;
      this.$router.push('/#');
    },
  }
}
</script>